// Copyright 2025 Diffblue Limited. All Rights Reserved.
// Unpublished proprietary source code.
// Use is governed by https://docs.diffblue.com/licenses/eula

import { AnalyticsBrowser } from "@dreamdata/analytics-next";

/**
 * Service to handle Dreamdata analytics tracking.
 *
 * Separated from DreamdataService to allow for easier mocking in tests.
 *
 * @see https://developer.dreamdata.io/
 */
const DreamdataAnalytics = AnalyticsBrowser.load({
  writeKey: process.env.REACT_APP_DREAMDATA_API_KEY ?? ""
});

export default DreamdataAnalytics;
